import {
    commentsStateKey,
    initialCommentsState,
    CommentsState,
    PostsCommentsState,
} from 'mk2/apps/blogs/containers/Comments/Comments.reducers';
import { memoizeOne } from 'mk2/helpers/cache';
import { AppState } from 'mk2/reducers';
import { CommentEntity, CommentParent } from 'mk2/schemas';

export const getCommentsState = (state: AppState, commentsParent: CommentParent): CommentsState =>
    state.containers.blogs.shared.comments[commentsStateKey(commentsParent)] || initialCommentsState;

export const getCommentsNonDeleted = memoizeOne(
    (comments: CommentEntity[]): CommentEntity[] => comments.filter((comment) => !comment.deletedAt),
);

export const getPostsState = (state: AppState): PostsCommentsState =>
    state.containers.blogs.shared.comments;

export const getCommentIdsOrNull = (state: PostsCommentsState, key: string) =>
    state[key] ? state[key].ids : null;
